<template>
    <div class="permuat-dialog">
        <el-dialog
            title="提示"
            width="500px"
            :show-close="false"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false">
        <div class="permuat-dialog-main">尊敬的用户您好：</div>
        <div class="permuat-dialog-main permuat-dialog-line">由于您的账号未申请二级节点系统相关权限，目前无法继续使用，页面将于{{count}}s后为您跳转权限自助申请页面。</div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="permuatCancel">取 消</el-button>
            <el-button type="primary" @click="permuatSkip">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
import config from '@/config/user.env';
import { logout } from '@/utils/index';
export default {
    data() {
        return {
            count: 10,
            dialogVisible: false
        };
    },
    methods: {
        permuatSkip() {
            window.location.href = config.MIDEA_SYSTEM;
        },
        permuatCancel() {
            logout();
        },
        countdown() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.count--;
            if (this.count === 0) {
                this.permuatSkip();
                return;
            }
            this.timer = setTimeout(() => {
                this.countdown();
            }, 1000);
        }
    },
    mounted() {
        this.countdown();
    }
};
</script>
<style lang="less">
.permuat-dialog{
    .permuat-dialog-main{
        font-size: 14px;
    }
    .permuat-dialog-line{
        text-indent: 2em;
    }
}
</style>